import TableOperations from 'mini-mail-list-table-operations';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { orchestrator } from 'satcheljs';
import { removeTableView } from '../../actions/tables/removeTableView';

/**
 * Orchestrator to remove tableView, and all it's mail items, from list-view store and mail store.
 * Mail items from mail store are removed only if they're not present in any other list-view table.
 * Check TableOperation.clear for more info.
 */
export default orchestrator(removeTableView, payload => {
    const { oldTableView } = payload;

    TableOperations.clear(oldTableView, null /* skipRowsNewerThanTime*/);
    getListViewStore().tableViews.delete(oldTableView.id);
});
